module.exports = __webpack_public_path__ + "img/32.02c63f2c.webp";